/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../../shared/types/__generated__/graphql"
import { ProjectHistoryFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type ProjectHistoryQueryVariables = Exact<{
  resourceType: string
  id: string
  from?: string | null
  to?: string | null
  limit?: number | null
  before?: string | null
  after?: string | null
}>

export type ProjectHistoryQuery = {
  __typename: "Query"
  projectHistory: {
    __typename: "ProjectHistory"
    id: string
    links: {
      __typename: "ProjectHistoryLinks"
      prev?: string | null
      next?: string | null
    }
    entries: Array<{
      __typename: "ProjectHistoryEntry"
      id: string
      action: string
      timestamp: string
      label?: string | null
      entityType: string
      changes?: Array<{
        __typename: "ProjectHistoryChange"
        field: string
        newValue?: string | null
        oldValue?: string | null
      }> | null
      entity: {
        __typename: "ProjectHistoryEntity"
        id: string
        label?: string | null
        type: string
        displayPosition?: string | null
        variantKey?: string | null
      }
      fromEntity: {
        __typename: "ProjectHistoryEntity"
        id: string
        label?: string | null
        type: string
        displayPosition?: string | null
        variantKey?: string | null
      }
      toEntity: {
        __typename: "ProjectHistoryEntity"
        id: string
        label?: string | null
        type: string
        displayPosition?: string | null
        variantKey?: string | null
      }
      project: {
        __typename: "ProjectHistoryProject"
        id: string
        title?: string | null
        type: string
      }
      user: {
        __typename: "ProjectHistoryUser"
        id: string
        name?: string | null
        email?: string | null
        type: string
      }
    }>
  }
}

export const ProjectHistoryDocument = gql`
  query ProjectHistory(
    $resourceType: String!
    $id: ID!
    $from: String = ""
    $to: String = ""
    $limit: Int
    $before: String = ""
    $after: String = ""
  ) {
    projectHistory(
      resourceType: $resourceType
      id: $id
      from: $from
      to: $to
      limit: $limit
      before: $before
      after: $after
    )
      @rest(
        type: "ProjectHistory"
        endpoint: "projectHistory"
        path: "/project-list/{args.resourceType}/{args.id}/changelog-entries?from={args.from}&to={args.to}&limit={args.limit}&before={args.before}&after={args.after}"
      ) {
      ...ProjectHistory
    }
  }
  ${ProjectHistoryFragmentDoc}
`

/**
 * __useProjectHistoryQuery__
 *
 * To run a query within a React component, call `useProjectHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectHistoryQuery({
 *   variables: {
 *      resourceType: // value for 'resourceType'
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useProjectHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProjectHistoryQuery,
    ProjectHistoryQueryVariables
  > &
    (
      | { variables: ProjectHistoryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectHistoryQuery, ProjectHistoryQueryVariables>(
    ProjectHistoryDocument,
    options
  )
}
export function useProjectHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectHistoryQuery,
    ProjectHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectHistoryQuery, ProjectHistoryQueryVariables>(
    ProjectHistoryDocument,
    options
  )
}
// @ts-ignore
export function useProjectHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectHistoryQuery,
    ProjectHistoryQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProjectHistoryQuery,
  ProjectHistoryQueryVariables
>
export function useProjectHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectHistoryQuery,
        ProjectHistoryQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProjectHistoryQuery | undefined,
  ProjectHistoryQueryVariables
>
export function useProjectHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectHistoryQuery,
        ProjectHistoryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProjectHistoryQuery,
    ProjectHistoryQueryVariables
  >(ProjectHistoryDocument, options)
}
export type ProjectHistoryQueryHookResult = ReturnType<
  typeof useProjectHistoryQuery
>
export type ProjectHistoryLazyQueryHookResult = ReturnType<
  typeof useProjectHistoryLazyQuery
>
export type ProjectHistorySuspenseQueryHookResult = ReturnType<
  typeof useProjectHistorySuspenseQuery
>
export type ProjectHistoryQueryResult = Apollo.QueryResult<
  ProjectHistoryQuery,
  ProjectHistoryQueryVariables
>
